<script>
    import Zufi from "./Zufi.svelte";
    import DoorClosed from "./DoorClosed.svelte";
</script>

<g>
    <rect style="stroke:#000;stroke-width:2;fill:white;fill-opacity:0.5;" width="80" height="140" x="0" y="0"/>
    <g transform="scale(-0.4 1) skewY(20)">
        <DoorClosed />
    </g>
    <g transform="translate(10 0)">
        <Zufi />
    </g>
</g>